"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = exports.overrideIsFetching = exports.overrideCreator = exports.isEnvProd = exports.complete = exports.cancelAll = exports.baseUrl = exports.SUCCESS = exports.REQUEST = exports.HTTP_REQUEST = exports.HTTP_OVERRIDE_IS_FETCHING = exports.HTTP_OVERRIDE = exports.HTTP_COMPLETE = exports.HTTP_CANCEL_ALL = exports.HTTP_ADD_CANCEL = exports.FAILURE = exports.COMPLETE = void 0;

var _reduxActions = require("redux-actions");

var _env = require("../env");

var REQUEST = 'REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;
var COMPLETE = 'COMPLETE';
/**
 * @deprecated Moved to env.js
 */

exports.COMPLETE = COMPLETE;
var isEnvProd = typeof window !== 'undefined' && window.location && window.location.hostname.indexOf('figure.com') > -1 && window.location.hostname.indexOf('test') < 0; // TODO: better handling of domain based on env var

exports.isEnvProd = isEnvProd;

var baseUrl = function baseUrl() {
  return "https://".concat((0, _env.getProd)() ? 'www.' : 'test.', "figure.com");
};

exports.baseUrl = baseUrl;
var HTTP_REQUEST = "HTTP_".concat(REQUEST);
exports.HTTP_REQUEST = HTTP_REQUEST;
var HTTP_COMPLETE = "HTTP_".concat(COMPLETE);
exports.HTTP_COMPLETE = HTTP_COMPLETE;
var HTTP_OVERRIDE = 'HTTP_OVERRIDE';
exports.HTTP_OVERRIDE = HTTP_OVERRIDE;
var HTTP_ADD_CANCEL = 'HTTP_ADD_CANCEL';
exports.HTTP_ADD_CANCEL = HTTP_ADD_CANCEL;
var HTTP_CANCEL_ALL = 'HTTP_CANCEL_ALL';
exports.HTTP_CANCEL_ALL = HTTP_CANCEL_ALL;
var HTTP_OVERRIDE_IS_FETCHING = 'HTTP_OVERRIDE_IS_FETCHING';
exports.HTTP_OVERRIDE_IS_FETCHING = HTTP_OVERRIDE_IS_FETCHING;
var request = (0, _reduxActions.createAction)(HTTP_REQUEST);
exports.request = request;
var complete = (0, _reduxActions.createAction)(HTTP_COMPLETE);
exports.complete = complete;

var overrideCreator = function overrideCreator(payloadCreator) {
  return (0, _reduxActions.createAction)(HTTP_OVERRIDE, payloadCreator);
};

exports.overrideCreator = overrideCreator;
var cancelAll = (0, _reduxActions.createAction)(HTTP_CANCEL_ALL);
exports.cancelAll = cancelAll;
var overrideIsFetching = (0, _reduxActions.createAction)(HTTP_OVERRIDE_IS_FETCHING);
exports.overrideIsFetching = overrideIsFetching;